import type { ArtistStatus } from '../types';

export const approvalBadgeClass = (finalStatus: string): string => {
    switch (finalStatus) {
        case 'approved': return 'badge badge-success';
        case 'rejected': return 'badge badge-danger';
        case 'pending':  return 'badge badge-warning';
        case 'raw':      return 'badge badge-muted';
        default:         return 'badge';
    }
};

export const creditBadgeClass = (status: string): string => {
    switch (status) {
        case 'approved':      return 'credit-badge credit-badge-approved';
        case 'auto_approved': return 'credit-badge credit-badge-auto_approved';
        case 'rejected':      return 'credit-badge credit-badge-rejected';
        default:              return 'credit-badge credit-badge-pending';
    }
};

export const photoStatusTooltip = (status: string): string => {
    switch (status) {
        case 'approved': return 'All tagged artists have approved this photo';
        case 'rejected': return 'At least one tagged artist rejected this photo';
        case 'pending':  return 'Waiting on one or more artist responses';
        case 'raw':      return 'Not yet sent for artist approval';
        default:         return '';
    }
};

export const formatCountdown = (endTime: string | null, state: string): string => {
    if (state === 'not_started') return '—';
    if (!endTime || state === 'expired') return 'Expired';
    const ms = new Date(endTime).getTime() - Date.now();
    if (ms <= 0) return 'Expired';
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    if (h === 0 && m < 1) return '< 1m';
    if (h === 0) return `${m}m`;
    return `${h}h ${m}m`;
};

export const notifShortLabel = (status: ArtistStatus['notificationStatus']): string => {
    switch (status) {
        case 'sent':    return '✓';
        case 'failed':  return '⚠ failed';
        case 'bounced': return '⚠ bounced';
        case 'pending': return 'pending';
        default:        return '—';
    }
};

export const notifTooltip = (status: ArtistStatus['notificationStatus']): string => {
    switch (status) {
        case 'sent':    return 'Approval link email sent';
        case 'failed':  return 'Approval link email failed to send';
        case 'bounced': return 'Approval link email bounced';
        case 'pending': return 'Approval link email not yet sent';
        default:        return 'Notification status unknown';
    }
};

export const timerTooltip = (state: string): string => {
    if (state === 'not_started') return 'Approval window has not started yet';
    if (state === 'expired') return 'Approval window has closed';
    return 'Time remaining in the 24-hour approval window';
};

export const creditStatusTooltip = (status: string): string => {
    switch (status) {
        case 'approved':      return 'Artist approved this photo';
        case 'auto_approved': return 'Automatically approved after the 24-hour window expired';
        case 'rejected':      return 'Artist rejected this photo';
        default:              return 'Awaiting artist response';
    }
};